import React from 'react';
import { HeaderTemplate, Stepper } from 'web-library';
import { useTranslation } from 'react-i18next';
import ExamReviewParticulars from '../../modules/examRegistration/components/ExamReviewParticulars';
import ExamTypeUuidDisplay from '../../modules/examRegistration/components/ExamTypeUuidDisplay';
import ExamTitle from '../../modules/examRegistration/components/ExamTitle';

interface ReviewParticularsProps {
  routeSteps: { label: string }[];
}

const ReviewParticulars = ({ routeSteps }: ReviewParticularsProps) => {
  const { t } = useTranslation();
  return (
    <>
      <ExamTitle />
      <HeaderTemplate>
        <ExamTypeUuidDisplay />
        <div>
          <Stepper activeStep={2} steps={routeSteps} />
        </div>
      </HeaderTemplate>
      <ExamReviewParticulars title={t('exam->>ReviewExam.Confirm Particulars')} />
    </>
  );
};

export default ReviewParticulars;
